import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import {
	INSPIRATION_SCENARIO_LABELS,
	INSPIRATION_SCENARIO_RATES,
} from "web_myplann/Inspiration/constants";
import { useEarlyFreedomYearsLabel } from "web_myplann/Inspiration/EarlyFreedom/Hooks/useEarlyFreedomYearsLabel";
import type { EarlyFreedomContext } from "web_myplann/Inspiration/EarlyFreedom/Types/EarlyFreedomTypes";
import { getEarlyFreedomTargetYears } from "web_myplann/Inspiration/EarlyFreedom/Utils/getEarlyFreedomTargetYears";
import type { InspirationGoalRecap } from "web_myplann/Inspiration/Types/InspirationTypes";
import { formatInspirationMoney } from "web_myplann/Inspiration/Utils/inspirationMoney";
import { formatPercent } from "web_myplann/Shared/Utils/numberFormatters";

const R = Resources.Inspiration.EarlyFreedom.CreateGoalSheet;

export const useEarlyFreedomGoalRecap = (
	context: EarlyFreedomContext,
): InspirationGoalRecap => {
	const { t } = useResource();
	const formatYears = useEarlyFreedomYearsLabel();

	const money = (value: number) => formatInspirationMoney(value);

	return {
		title: t(R.title),
		description: t(R.description),
		footnote: t(R.footnote),
		continueLabel: t(R.continue),
		rows: [
			{
				label: t(R.rentLabel),
				note:
					context.passiveToday > 0
						? t(R.rentNoteWithPassive, {
								expenses: money(context.targetExpenses),
								passive: money(context.passiveToday),
							})
						: t(R.rentNote),
				value: money(context.gap),
			},
			{
				label: t(R.dueDateLabel),
				note: t(R.dueDateNote, {
					scenario: t(INSPIRATION_SCENARIO_LABELS[context.selectedScenario]),
					rate: formatPercent(
						INSPIRATION_SCENARIO_RATES[context.selectedScenario] * 100,
						0,
					),
				}),
				value: formatYears(getEarlyFreedomTargetYears(context)),
			},
			{
				label: t(R.capitalLabel),
				note: t(R.capitalNote),
				value: money(context.targetCapital),
				highlight: true,
				dividerBefore: true,
			},
		],
	};
};
